import axios from "axios";

//export const databaseURL = "https://backend.risetogether.site/api/v1/";
//export const databaseURL = "https://test.api.rise.risetogether.site/api/v1/";
export const databaseURL =
  process.env.REACT_APP_DATABASE_URL || "/api/v1/";

export const userRole = {
  admin: "Admin",
  developper: "Developper",
  distributor: "Distributor",
};

// Bug de production signalé le 22/09/2026 : une image de News chargée par
// l'administrateur restait invisible pour les distributeurs et les Home
// Stock, alors que le titre et le texte s'affichaient normalement.
//
// CAUSE : les pièces jointes de News vivent sur le disque du serveur
// backend (`backend/uploads/news/`), et l'API renvoie une URL RELATIVE
// (`/uploads/news/xxx.jpg`) — utilisée telle quelle dans <img src>, sans la
// faire précéder de l'origine du backend, contrairement à tous les appels
// API du projet qui passent par `databaseURL` (déjà absolue). En
// production, frontend et backend sont deux domaines séparés
// (`deployment_guide.md`) : une URL relative se résout donc contre le
// domaine du FRONTEND, qui n'a jamais eu ce fichier — 404 silencieux. En
// local, `proxy` dans package.json masque le défaut par accident.
//
// `databaseURL` vaut ".../api/v1/" (absolue en prod, relative "/api/v1/"
// en dev) ; on retire ce suffixe pour obtenir l'origine du backend seul.
const origineApi = databaseURL.replace(/\/api\/v1\/?$/, "");

/** Fait précéder une URL de fichier téléversé (News, etc.) par l'origine du
 * backend si elle est relative ; ne touche pas à une URL déjà absolue. */
export const urlFichierTeleverse = (url) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  return `${origineApi}${url}`;
};

// Session glissante de 30 minutes (15/09/2026) : se déconnecter supprime
// désormais réellement la session côté serveur (POST /users/logout), plutôt
// que de se contenter d'effacer l'état local. Un échec réseau ne doit jamais
// empêcher l'utilisateur de quitter l'écran — la déconnexion locale a déjà
// eu lieu par ailleurs (dispatch(deleteUser())), on tente juste la
// révocation côté serveur en plus.
export const deconnecterUtilisateur = async (token) => {
  if (!token) return;
  try {
    await axios.post(`${databaseURL}users/logout`, {}, { headers: { Authorization: `Bearer ${token}` } });
  } catch (erreur) {
    console.error("Erreur lors de la révocation de la session:", erreur);
  }
};

// Résout l'image d'un produit : la base stocke un nom de fichier nu
// (ex. "grand-mangwa.jpg"), à faire suivre du dossier des visuels.
export const getProductImage = (product) => {
  if (product?.image && typeof product.image === "string" && product.image.length > 5) {
    if (/^(https?:)?\//.test(product.image)) return product.image;
    return `/assets/products/${product.image}`;
  }
  const name = (product?.name || "").toLowerCase();
  if (name.includes("grand") || name.includes("red") || name.includes("75")) {
    return "/assets/products/grand-mangwa.jpg";
  }
  if (name.includes("drink") || name.includes("therapeutic") || name.includes("33")) {
    return "/assets/products/mangwa-330.jpg";
  }
  return null;
};

// Résume les produits d'une commande ("GRAND MANGWA Red ×2, ..."), en lisant
// les lignes réelles plutôt que le champ `description` de la commande, qui ne
// porte qu'un texte générique figé à la création ("Order products").
export const orderProductsSummary = (order, fallback = "Commande boutique") => {
  if (Array.isArray(order?.products) && order.products.length > 0) {
    return order.products
      .map((p) => `${p.product?.name || "Produit"} ×${p.quantity}`)
      .join(", ");
  }
  return fallback;
};

